export function pad2(n) {
  return String(n).padStart(2, "0");
}

export function minutesToTimeStr(minutes) {
  if (minutes == null || isNaN(minutes)) return "09:00";
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${pad2(h)}:${pad2(m)}`;
}

export function timeStrToMinutes(str) {
  if (!str) return 0;
  const parts = str.split(":");
  return parseInt(parts[0]) * 60 + parseInt(parts[1]);
}

export function timestampToDateStr(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

export function timestampToTimeStr(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}
